import React, { useRef, useEffect, useState } from "react";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import landingVideo from "../../assets/Images/Landing/KGM Landing Page (1).mp4";
import { IoArrowForward, IoPlay } from "react-icons/io5";
import { useIsMobile } from "../../utils/responsive";
import SEO from "../SEO";

export default function Landing() {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const videoRef = useRef(null);
  const [showPlayButton, setShowPlayButton] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.muted = true;
      video.playsInline = true;
      video.setAttribute("playsinline", "true");

      const handlePlay = () => {
        setShowPlayButton(false);
      };

      video.addEventListener("play", handlePlay);

      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          console.warn("Autoplay was prevented:", error);
          // Show play button if autoplay fails (common on mobile)
          if (isMobile) {
            setShowPlayButton(true);
          }
        });
      }

      return () => {
        video.removeEventListener("play", handlePlay);
      };
    }
  }, [isMobile]);

  const handlePlayButtonClick = () => {
    const video = videoRef.current;
    if (video) {
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            setShowPlayButton(false);
          })
          .catch((error) => {
            console.error("Failed to play video:", error);
          });
      }
    }
  };

  // Structured data for the landing page
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Kritika Goswamy Malik - Interior Designer Portfolio",
    description:
      "Welcome to the portfolio of Kritika Goswamy Malik, a renowned interior designer crafting poetry in space and form. Specializing in residential, corporate, hospitality, and healthcare design projects.",
    url: "https://kritikagoswamymalik.com/",
    about: {
      "@type": "Person",
      name: "Kritika Goswamy Malik",
      jobTitle: "Interior Designer",
      description: "Crafting poetry in space and form",
    },
    mainEntity: {
      "@type": "ProfessionalService",
      name: "KGM Interiors",
      description:
        "Interior design services specializing in residential, corporate, hospitality, and healthcare projects",
    },
  };

  return (
    <>
      <SEO
        title="Welcome to KGM Interiors"
        description="Welcome to the portfolio of Kritika Goswamy Malik, a renowned interior designer crafting poetry in space and form. Specializing in residential, corporate, hospitality, and healthcare design projects with timeless elegance and modern sensibilities."
        keywords="portfolio, interior design showcase, residential design, corporate interiors, hospitality design, healthcare interiors, luxury design"
        canonicalUrl="/"
        structuredData={structuredData}
      />

      <Container fluid className="p-0">
        <div
          style={{
            position: "relative",
            height: "100vh",
            overflow: "hidden",
          }}
        >
          <video
            ref={videoRef}
            src={landingVideo}
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            style={{
              width: "100vw",
              height: "100vh",
              objectFit: "cover",
              display: "block",
            }}
          />

          {/* Dark Overlay */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
          ></div>

          {/* Play Button Overlay for Mobile */}
          {showPlayButton && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "rgba(0, 0, 0, 0.3)",
                zIndex: 1000,
              }}
            >
              <Button
                variant="link"
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  backgroundColor: "rgba(255, 255, 255, 0.9)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.3s ease",
                  color: "#333",
                  textDecoration: "none",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
                  cursor: "pointer",
                  animation: "pulse 2s infinite",
                }}
                onClick={handlePlayButtonClick}
              >
                <IoPlay
                  style={{
                    fontSize: "32px",
                    marginLeft: "3px", // Slight offset to center the play icon
                  }}
                />
              </Button>
            </div>
          )}

          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-around",
            }}
          >
            {!isMobile && (
              <div
                className="d-flex justify-content-center"
                style={{ height: "10%" }}
              >
                <div
                  className="border-bottom-white border-right-white"
                  style={{
                    width: "5%",
                  }}
                ></div>
                <div
                  className="border-bottom-white border-right-white"
                  style={{
                    width: "10%",
                  }}
                ></div>
                <div
                  className="border-bottom-white border-right-white"
                  style={{
                    width: "80%",
                  }}
                ></div>
                <div
                  className="border-bottom-white border-right-white"
                  style={{
                    width: "10%",
                  }}
                ></div>
                <div
                  className="border-bottom-white border-left-white"
                  style={{
                    width: "5%",
                  }}
                ></div>
              </div>
            )}
            {!isMobile && (
              <div
                className="d-flex justify-content-center"
                style={{ height: "10%" }}
              >
                <div
                  className="border-bottom-white border-right-white"
                  style={{
                    width: "5%",
                  }}
                ></div>
                <div
                  className="border-bottom-white border-right-white"
                  style={{
                    width: "10%",
                  }}
                ></div>
                <div
                  className="border-bottom-white border-right-white"
                  style={{
                    width: "80%",

                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                ></div>
                <div
                  className="border-bottom-white border-right-white"
                  style={{
                    width: "10%",
                  }}
                ></div>
                <div
                  className="border-bottom-white border-left-white"
                  style={{
                    width: "5%",
                  }}
                ></div>
              </div>
            )}
            <div
              className="d-flex justify-content-center"
              style={{ height: "60%" }}
            >
              {!isMobile && (
                <div
                  className="border-bottom-white border-right-white"
                  style={{
                    width: "5%",
                  }}
                ></div>
              )}
              {!isMobile && (
                <div
                  className="border-bottom-white border-right-white"
                  style={{
                    width: "10%",
                  }}
                ></div>
              )}
              <div
                style={{
                  width: "80%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div className="text-center">
                  <h1 className="text-center heading-lg text-white">
                    KRITIKA GOSWAMY MALIK
                    <br />
                  </h1>
                  <h2 className="accent-text heading-md text-white">
                    crafting poetry in space and form
                  </h2>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "3rem",
                    }}
                  >
                    <div
                      style={{
                        position: "relative",
                        animation: "breathe 3s ease-in-out infinite",
                      }}
                    >
                      <Button
                        variant="link"
                        style={{
                          width: isMobile ? "45px" : "65px",
                          height: isMobile ? "45px" : "65px",
                          borderRadius: "50%",
                          backgroundColor: "rgba(255, 255, 255, 0.15)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                          color: "white",
                          textDecoration: "none",
                          backdropFilter: "blur(15px)",
                          boxShadow:
                            "0 8px 32px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)",
                          position: "relative",
                          cursor: "pointer",
                        }}
                        onClick={() => navigate("/home")}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor =
                            "rgba(255, 255, 255, 0.25)";
                          e.currentTarget.style.transform =
                            "translateX(10px) scale(1.05)";
                          e.currentTarget.style.boxShadow =
                            "0 12px 40px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.2)";
                          e.currentTarget.style.borderColor =
                            "rgba(255, 255, 255, 0.4)";
                          e.currentTarget.parentElement.style.animation =
                            "none";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor =
                            "rgba(255, 255, 255, 0.15)";
                          e.currentTarget.style.transform =
                            "translateX(0) scale(1)";
                          e.currentTarget.style.boxShadow =
                            "0 8px 32px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)";
                          e.currentTarget.style.borderColor =
                            "rgba(255, 255, 255, 0.25)";
                          e.currentTarget.parentElement.style.animation =
                            "breathe 3s ease-in-out infinite";
                        }}
                      >
                        <IoArrowForward
                          style={{
                            fontSize: "28px",
                            transition: "transform 0.3s ease",
                          }}
                        />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              {!isMobile && (
                <div
                  className="border-bottom-white border-right-white border-left-white"
                  style={{
                    width: "10%",
                  }}
                ></div>
              )}
              {!isMobile && (
                <div
                  className="border-bottom-white border-left-white"
                  style={{
                    width: "5%",
                  }}
                ></div>
              )}
            </div>

            {!isMobile && (
              <div
                className="d-flex justify-content-center"
                style={{ height: "10%" }}
              >
                <div
                  className="border-bottom-white border-right-white"
                  style={{
                    width: "5%",
                  }}
                ></div>
                <div
                  className="border-bottom-white border-right-white"
                  style={{
                    width: "10%",
                  }}
                ></div>
                <div
                  className="border-bottom-white border-right-white border-top-white"
                  style={{
                    width: "80%",

                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                ></div>
                <div
                  className="border-bottom-white "
                  style={{
                    width: "10%",
                  }}
                ></div>
                <div
                  className="border-bottom-white border-left-white"
                  style={{
                    width: "5%",
                  }}
                ></div>
              </div>
            )}
            {!isMobile && (
              <div
                className="d-flex justify-content-center"
                style={{ height: "10%" }}
              >
                <div
                  className=" border-right-white"
                  style={{
                    width: "5%",
                  }}
                ></div>
                <div
                  className="border-right-white"
                  style={{
                    width: "10%",
                  }}
                ></div>
                <div
                  className="border-right-white"
                  style={{
                    width: "80%",
                  }}
                ></div>
                <div
                  style={{
                    width: "10%",
                  }}
                ></div>
                <div
                  className="border-left-white"
                  style={{
                    width: "5%",
                  }}
                ></div>
              </div>
            )}
          </div>
        </div>
      </Container>
    </>
  );
}
